// removed by extract-text-webpack-plugin
module.exports = {"container":"mobileNavMenu__container__e10f4aac","isOpen":"mobileNavMenu__isOpen__e10f4aac","bodyContainer":"mobileNavMenu__bodyContainer__e10f4aac","bodyItem":"mobileNavMenu__bodyItem__e10f4aac"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavMenu/mobileNavMenu.scss
// module id = ./src/components/MobileNav/MobileNavMenu/mobileNavMenu.scss
// module chunks = 4